(function () {
  if (window.__acquaArisDrawerBound) return;
  window.__acquaArisDrawerBound = true;

  function bind() {
    const data = window.AvisOptionsData;
    if (!data || data.afterAddToCart?.__acquaArisDrawerCallback) return;

    const previous = data.afterAddToCart;
    const afterAddToCart = async function (response) {
      const handled = typeof previous === 'function'
        ? await previous.apply(this, arguments)
        : undefined;
      if (handled) return handled;

      const drawer = window.acquaCartDrawer;
      if (response && !response.status && !response.description
        && Array.isArray(response.items) && response.items.length
        && drawer?.active && typeof drawer.nativeAdded === 'function') {
        // Aris calls this after its complete configured addition succeeds.
        // A true result suppresses its fallback redirect; the drawer verifies cart state.
        // Begin a fresh lifecycle so an earlier dismissed add cannot suppress this one.
        if (typeof drawer.beginAdd === 'function') drawer.beginAdd();
        drawer.nativeAdded();
        return true;
      }
      return handled;
    };
    afterAddToCart.__acquaArisDrawerCallback = true;
    data.afterAddToCart = afterAddToCart;
  }

  document.addEventListener('productoptions.appLoad', bind);
  document.addEventListener('avisOptionsLoaded', bind);
  document.addEventListener('DOMContentLoaded', bind);
  bind();
})();
